import React from "react";

const UpgradePlan = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12 text-center">
                    <h3>Your current plan does not include these features.</h3>
                    <h6 className="mt-20"> Please contact admin@myconsole.co.uk to upgrade your plan.</h6>
                </div>
            </div>
        </div>
    )
}

export default UpgradePlan